import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { normalizeLang, langMeta } from "./languages";
import en from "./locales/en.json";
import hi from "./locales/hi.json";
import mr from "./locales/mr.json";
import gu from "./locales/gu.json";
import ta from "./locales/ta.json";
import bn from "./locales/bn.json";
import ml from "./locales/ml.json";
import te from "./locales/te.json";
import ur from "./locales/ur.json";
import pa from "./locales/pa.json";

const resources = {
  en: { translation: en },
  hi: { translation: hi },
  mr: { translation: mr },
  gu: { translation: gu },
  ta: { translation: ta },
  bn: { translation: bn },
  ml: { translation: ml },
  te: { translation: te },
  ur: { translation: ur },
  pa: { translation: pa },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function applyDocumentLang(code) {
  const meta = langMeta(code);
  if (typeof document === "undefined") return;
  document.documentElement.lang = meta.code;
  document.documentElement.dir = meta.dir || "ltr";
}

export async function setAppLanguage(code) {
  const lng = normalizeLang(code);
  await i18n.changeLanguage(lng);
  applyDocumentLang(lng);
  return lng;
}

export default i18n;
